import { pickBy, identity, omit, difference, isUndefined } from 'lodash';
import ReactDOM from 'react-dom';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Returns the first and last initials of a user
function userInitials(user) {
  var firstInitial = user.first_name ? user.first_name[0] : '';
  var lastInitial = user.last_name ? user.last_name[0] : '';
  return firstInitial + lastInitial;
} // Returns the user's first and last name


function userName(user) {
  var firstName = user.first_name || '';
  var lastName = user.last_name || '';
  return "".concat(firstName, " ").concat(lastName).trim();
}

function Avatar(props) {
  var uName = userName(props.user); // Creates an avatar with an image

  function imageAvatar(props) {
    var imgClasses = "rounded-circle img-fluid";
    return /*#__PURE__*/React.createElement("img", {
      src: props.image_url,
      alt: uName,
      title: uName,
      className: imgClasses
    });
  } // Creates an avatar with a user's initials and a colored background


  function skittlesAvatar(props) {
    // There are 9 different colors for the skittles avatar
    // returns an integer 0-8
    function skittlesVariation(n) {
      var totalAvatarVariations = 9;
      return n % totalAvatarVariations;
    }

    var skittlesVar = skittlesVariation(props.user.id);
    var skittlesClasses = "rounded-circle skittles-avatar skittles-avatar-".concat(skittlesVar);
    var initials = userInitials(props.user);
    return /*#__PURE__*/React.createElement("div", {
      className: skittlesClasses,
      "data-initials": initials,
      title: uName
    });
  }

  var avatar = props.image_url ? imageAvatar(props) : skittlesAvatar(props);
  var size = props.size || "sm";
  var avatarClasses = "avatar avatar-".concat(size);
  return /*#__PURE__*/React.createElement("div", {
    className: avatarClasses
  }, avatar);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function Button(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      link = _ref.link,
      name = _ref.name,
      onClick = _ref.onClick,
      style = _ref.style,
      target = _ref.target,
      type = _ref.type,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "disabled", "link", "name", "onClick", "style", "target", "type", "value"]);

  function linkButton() {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: buttonClasses,
      href: link,
      onClick: onClick,
      target: target
    }, otherProps), children);
  } // lmao


  function buttonButton() {
    return /*#__PURE__*/React.createElement("button", _extends({
      className: buttonClasses,
      disabled: disabled,
      name: name,
      onClick: onClick,
      type: type,
      value: value
    }, otherProps), children);
  }

  var buttonClasses = classNames((_classNames = {
    btn: style === 'primary'
  }, _defineProperty(_classNames, 'btn-' + style, true), _defineProperty(_classNames, "disabled", link && disabled), _defineProperty(_classNames, className, className), _classNames));
  var button = link ? linkButton() : buttonButton();
  return button;
}

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  link: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.oneOf(['flat', 'floating', 'icon', 'primary', 'stroked']),
  target: PropTypes.oneOf(['', '_blank']),
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  value: PropTypes.string
};
Button.defaultProps = {
  children: '',
  className: '',
  disabled: false,
  link: '',
  name: '',
  onClick: function onClick() {},
  style: 'primary',
  target: '',
  type: 'button',
  value: ''
};

function Banner(_ref) {
  var primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction,
      text = _ref.text;

  function buildAction(action) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!action) {
      return;
    }

    if (action.dismiss) {
      return /*#__PURE__*/React.createElement(Button, _extends({
        className: "dismiss-banner"
      }, args), "Dismiss");
    } else {
      return /*#__PURE__*/React.createElement(Button, _extends({
        className: action.className,
        link: action.link
      }, args), action.text);
    }
  }

  var pAction = buildAction(primaryAction);
  var sAction = buildAction(secondaryAction, {
    style: "flat"
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "banner z-depth-1"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "navbar n2-navbar justify-content-between px-3 py-2 white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner-text-parent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner-text"
  }, text)), /*#__PURE__*/React.createElement("div", {
    className: "banner-action d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pr-3"
  }, sAction), pAction)));
}

Banner.propTypes = {
  primaryAction: PropTypes.object,
  secondaryAction: PropTypes.object,
  text: PropTypes.string
};
Banner.defaultProps = {
  primaryAction: null,
  secondaryAction: null,
  text: ''
};

function Icon(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      label = _ref.label;
  // It's preferred if a label has been added to describe the icon, but if there isn't a label,
  // we'll use the icon string.
  var ariaLabel = label || icon;
  var iconClasses = classNames(_defineProperty({
    'material-icons': true
  }, className, className));
  return /*#__PURE__*/React.createElement("i", {
    className: iconClasses,
    "aria-label": ariaLabel
  }, icon);
}

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string
};
Icon.defaultProps = {
  className: '',
  icon: '',
  label: ''
};

function IconButton(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      icon = _ref.icon,
      label = _ref.label,
      link = _ref.link,
      name = _ref.name,
      style = _ref.style,
      target = _ref.target,
      type = _ref.type,
      value = _ref.value;
  var buttonProps = {
    className: className,
    disabled: disabled,
    link: link,
    name: name,
    style: style || "icon",
    target: target,
    type: type,
    value: value
  };
  return /*#__PURE__*/React.createElement(Button, buttonProps, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    label: label
  }));
}

var Card = /*#__PURE__*/function (_React$Component) {
  _inherits(Card, _React$Component);

  var _super = _createSuper(Card);

  function Card() {
    _classCallCheck(this, Card);

    return _super.apply(this, arguments);
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var classes = "card animated fadeIn ".concat(this.props.className || "");
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id || null,
        className: classes
      }, this.props.children);
    }
  }]);

  return Card;
}(React.Component);

var CardBody = /*#__PURE__*/function (_React$Component) {
  _inherits(CardBody, _React$Component);

  var _super = _createSuper(CardBody);

  function CardBody() {
    _classCallCheck(this, CardBody);

    return _super.apply(this, arguments);
  }

  _createClass(CardBody, [{
    key: "render",
    value: function render() {
      var classes = "p-3 ".concat(this.props.className || "");
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, this.props.children);
    }
  }]);

  return CardBody;
}(React.Component);

var CardContent = /*#__PURE__*/function (_React$Component) {
  _inherits(CardContent, _React$Component);

  var _super = _createSuper(CardContent);

  function CardContent() {
    _classCallCheck(this, CardContent);

    return _super.apply(this, arguments);
  }

  _createClass(CardContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          target = _this$props.target,
          collapsible = _this$props.collapsible,
          className = _this$props.className,
          opened = _this$props.opened;
      var classes = className || "";

      if (collapsible && !opened) {
        classes += " collapse";
      } else if (collapsible && opened) {
        classes += " collapse show";
      }

      return /*#__PURE__*/React.createElement("div", {
        id: target,
        className: classes
      }, this.props.children);
    }
  }]);

  return CardContent;
}(React.Component);

var CardFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(CardFooter, _React$Component);

  var _super = _createSuper(CardFooter);

  function CardFooter() {
    _classCallCheck(this, CardFooter);

    return _super.apply(this, arguments);
  }

  _createClass(CardFooter, [{
    key: "render",
    value: function render() {
      var classes = "n2-card-footer ".concat(this.props.className || "");
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, this.props.children);
    }
  }]);

  return CardFooter;
}(React.Component);

var CardHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(CardHeader, _React$Component);

  var _super = _createSuper(CardHeader);

  function CardHeader() {
    _classCallCheck(this, CardHeader);

    return _super.apply(this, arguments);
  }

  _createClass(CardHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          target = _this$props.target,
          collapsible = _this$props.collapsible,
          opened = _this$props.opened,
          children = _this$props.children,
          className = _this$props.className;
      var classes = "n2-card-header ".concat(className || '');
      return collapsible ? /*#__PURE__*/React.createElement(CollapsibleCardHeader, {
        title: title,
        subtitle: subtitle,
        target: target,
        className: classes,
        opened: opened
      }) : /*#__PURE__*/React.createElement(DefaultCardHeader, {
        title: title,
        subtitle: subtitle,
        className: classes
      }, children);
    }
  }]);

  return CardHeader;
}(React.Component);

var DefaultCardHeader = function DefaultCardHeader(props) {
  var className = props.className,
      title = props.title,
      subtitle = props.subtitle,
      children = props.children,
      opened = props.opened;
  var titleElement = title ? /*#__PURE__*/React.createElement("h3", {
    className: "mb-0 grey-text text-darken-3"
  }, title) : '';
  var subtitleElement = subtitle ? /*#__PURE__*/React.createElement("p", {
    className: "m-0 grey-text text-darken-2"
  }, subtitle) : '';
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", null, titleElement, subtitleElement), children);
};

var CollapsibleCardHeader = function CollapsibleCardHeader(props) {
  var target = props.target,
      className = props.className,
      title = props.title,
      subtitle = props.subtitle,
      children = props.children,
      opened = props.opened;
  var classes = opened ? ' cursor-pointer' : ' cursor-pointer collapsed';
  return /*#__PURE__*/React.createElement("div", {
    className: className + classes,
    href: "#".concat(target),
    "data-toggle": "collapse",
    "aria-expanded": opened,
    "aria-controls": target
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "mb-0 grey-text text-darken-3"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "m-0 grey-text text-darken-2"
  }, subtitle)), /*#__PURE__*/React.createElement("i", {
    className: "material-icons collapse-icon"
  }, "keyboard_arrow_up"));
};

var CardImage = /*#__PURE__*/function (_React$Component) {
  _inherits(CardImage, _React$Component);

  var _super = _createSuper(CardImage);

  function CardImage() {
    _classCallCheck(this, CardImage);

    return _super.apply(this, arguments);
  }

  _createClass(CardImage, [{
    key: "render",
    value: function render() {
      var image = this.props.image;
      return /*#__PURE__*/React.createElement("div", {
        className: "view overlay hm-white-slight"
      }, /*#__PURE__*/React.createElement("img", {
        src: image,
        className: "img-fluid"
      }));
    }
  }]);

  return CardImage;
}(React.Component);

function Chip(_ref) {
  var actionable = _ref.actionable,
      className = _ref.className,
      imageUrl = _ref.imageUrl,
      text = _ref.text,
      theme = _ref.theme,
      user = _ref.user;
  var classes = classNames(_defineProperty({
    actionable: actionable,
    blue: theme === 'blue',
    chip: true,
    'darken-3': theme === 'dark',
    grey: ['light', 'dark'].includes(theme),
    'lighten-3': theme === 'light',
    'white-text': ['dark', 'blue'].includes(theme)
  }, className, className));
  var label = user ? userName(user) : text;
  var img = image();
  var xIcon = closeIcon();

  function image() {
    if (imageUrl) {
      return /*#__PURE__*/React.createElement("img", {
        alt: label,
        src: imageUrl
      });
    }
  }

  function closeIcon() {
    if (actionable) {
      var closeClasses = classNames({
        close: true,
        'material-icons': true,
        'white-text': ['dark', 'blue'].includes(theme)
      });
      return /*#__PURE__*/React.createElement("i", {
        className: closeClasses
      }, "close");
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, img, label, xIcon);
}

Chip.propTypes = {
  actionable: PropTypes.bool,
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  text: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark', 'blue']),
  user: PropTypes.object
};
Chip.defaultProps = {
  actionable: false,
  className: '',
  imageUrl: '',
  text: '',
  theme: 'light',
  user: null
};

function FormError(_ref) {
  var className = _ref.className,
      message = _ref.message;
  return /*#__PURE__*/React.createElement("small", {
    className: className
  }, message);
}

FormError.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string
};
FormError.defaultProps = {
  message: '',
  className: 'invalid red-text'
};

function FormLabel(_ref) {
  var className = _ref.className,
      htmlFor = _ref.htmlFor,
      label = _ref.label;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor,
    className: className
  }, label);
}

FormLabel.propTypes = {
  className: PropTypes.string,
  htmlFor: PropTypes.string,
  label: PropTypes.string
};
FormLabel.defaultProps = {
  className: '',
  htmlFor: '',
  label: ''
};

function Input(_ref) {
  var props = _extends({}, _ref);

  var className = props.className,
      isInvalid = props.isInvalid,
      invalidMessage = props.invalidMessage,
      id = props.id,
      label = props.label,
      isActive = props.isActive,
      onChange = props.onChange,
      propsValue = props.value;

  var _useState = useState(propsValue),
      _useState2 = _slicedToArray(_useState, 2),
      storedValue = _useState2[0],
      setValue = _useState2[1]; // If parent is handling onChange, use props, not stored state


  var value = onChange ? propsValue : storedValue;
  var checkActive = !!value || isActive;
  var labelClass = classNames({
    active: checkActive
  });
  var klass = classNames(className, {
    invalid: isInvalid
  });
  var inputDenylist = ['invalidMessage', 'isInvalid', 'isActive']; // select only the props that are defined and not in the denylist

  var inputOptions = pickBy(omit(props, inputDenylist), identity);

  function onInputChange(_ref2) {
    var target = _ref2.target,
        val = _ref2.target.value;

    if (onChange) {
      onChange({
        target: target
      });
    } else {
      setValue(val);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "md-form"
  }, /*#__PURE__*/React.createElement("input", _extends({}, inputOptions, {
    value: value,
    className: klass,
    onChange: onInputChange
  })), /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    className: labelClass,
    label: label
  }), isInvalid && /*#__PURE__*/React.createElement(FormError, {
    message: invalidMessage
  }));
}

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['text', 'password', 'email', 'number', 'tel', 'url']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isActive: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  isInvalid: PropTypes.bool,
  invalidMessage: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  step: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
  size: PropTypes.string,
  maxLength: PropTypes.string,
  minLength: PropTypes.string,
  pattern: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
};
Input.defaultProps = {
  id: '',
  name: '',
  isActive: false,
  className: '',
  type: 'text',
  value: '',
  disabled: false,
  readOnly: false,
  isInvalid: false,
  onChange: undefined,
  invalidMessage: '',
  label: '',
  placeholder: '',
  step: '',
  max: '',
  min: '',
  size: '',
  maxLength: '',
  minLength: '',
  pattern: ''
};

function usePrevious(val) {
  var ref = useRef();
  useEffect(function () {
    ref.current = val;
  });
  return ref.current;
}

function Select(_ref) {
  var props = _extends({}, _ref);

  /**
   * We can't destructure in the args since we need all props
   * in setting up the selectize object. So do it here:
   */
  var id = props.id,
      className = props.className,
      disabled = props.disabled,
      value = props.value,
      handleChange = props.handleChange,
      multiple = props.multiple,
      options = props.options,
      placeholder = props.placeholder,
      allowCreate = props.allowCreate,
      name = props.name;
  var inputRef = useRef();
  var previousOptions = usePrevious(options);
  var previousDisabled = usePrevious(disabled);
  var previousPlaceholder = usePrevious(placeholder);
  var previousValue = usePrevious(value);
  var selectizeOptNames = ['delimiter', 'diacritics', 'closeAfterSelect', 'create', 'createOnBlur', 'createFilter', 'highlight', 'persist', 'openOnFocus', 'maxOptions', 'maxItems', 'hideSelected', 'scrollDuration', 'loadThrottle', 'preload', 'dropdownParent', 'addPrecedence', 'selectOnTab', 'options', 'dataAttr', 'valueField', 'optgroupValueField', 'labelField', 'optgroupLabelField', 'optgroupField', 'sortField', 'searchField', 'searchConjunction', 'optgroups', 'optgroupOrder', 'load', 'score', 'render', 'plugins', 'allowCreate', 'placeholder', 'onBlur'];

  function noChangeToOptions(a1, a2) {
    // You have already compared the individual values at this point
    // So if they are not arrays, they do not match
    if (!Array.isArray(a1) || !Array.isArray(a2)) {
      return false;
    }

    var options1 = [];
    var options2 = []; // Convert object-based options to arrays for comparison

    a1.forEach(function (item) {
      if (item instanceof Object) {
        options1.push([item.text, item.value]);
      } else {
        options1.push(item);
      }
    });
    a2.forEach(function (item) {
      if (item instanceof Object) {
        options2.push([item.text, item.value]);
      } else {
        options2.push(item);
      }
    });
    return options1.length === options2.length && !options1.some(function (element, index) {
      return difference(options2[index], element).length > 1;
    });
  }

  function createNewOption(input) {
    return {
      value: input,
      text: input
    };
  }

  function handleItemRemove() {
    var selectized = inputRef.current.selectize;

    if (!selectized.settings.closeAfterSelect) {
      return;
    }

    selectized.$dropdown.css('opacity', '0');
    var that = selectized;
    setTimeout(function () {
      that.close();
      that.$dropdown.css('opacity', '1');
    }, 100);
  }

  function onChange(val) {
    handleChange(val);
  }

  function addOpt(opt) {
    if (opt instanceof Array) {
      return {
        text: opt[0],
        value: opt[1]
      };
    }

    return opt;
  }

  function updateIfNeccesary() {
    var selectized = inputRef.current.selectize;

    if (selectized) {
      selectized.off('change', onChange);
      selectized.off('item_remove', handleItemRemove);
    } else {
      var opts = {};
      selectizeOptNames.forEach(function (optName) {
        if (optName in props) {
          opts[optName] = props[optName];
        }
      });

      if (allowCreate) {
        opts.create = createNewOption;
      }

      selectized = $(inputRef.current).selectize(opts)[0].selectize;
    }

    if (isUndefined(previousOptions) || previousOptions !== options && !noChangeToOptions(previousOptions, options)) {
      selectized.clearOptions();
      selectized.addOption(options.map(function (opt) {
        return addOpt(opt);
      }));
      selectized.refreshOptions(false);
    }

    if (previousPlaceholder !== placeholder) {
      selectized.settings.placeholder = placeholder;
      selectized.updatePlaceholder();
    }

    if (isUndefined(previousValue) || previousValue !== value && !noChangeToOptions(previousValue, value)) {
      selectized.setValue(value);
    }

    if (previousDisabled !== disabled) {
      if (disabled) {
        selectized.disable();
      } else {
        selectized.enable();
      }
    }

    selectized.on('change', onChange);
    selectized.on('item_remove', handleItemRemove);
  }

  useEffect(function () {
    updateIfNeccesary();
  }, [value]);
  return /*#__PURE__*/React.createElement("select", {
    id: id,
    name: name,
    ref: inputRef,
    className: className,
    disabled: disabled,
    multiple: multiple
  });
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  multiple: PropTypes.bool,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number]),
  allowCreate: PropTypes.bool,
  allowEmptyOption: PropTypes.bool
};
Select.defaultProps = {
  id: '',
  name: '',
  className: '',
  disabled: false,
  value: '',
  handleChange: $.noop,
  multiple: false,
  options: [],
  placeholder: '',
  allowCreate: false,
  allowEmptyOption: false
};

var red = {
	"lighten-5": "#FFEBEE",
	"lighten-4": "#FFCDD2",
	"lighten-3": "#EF9A9A",
	"lighten-2": "#E57373",
	"lighten-1": "#EF5350",
	base: "#F44336",
	"darken-1": "#E53935",
	"darken-2": "#D32F2F",
	"darken-3": "#C62828",
	"darken-4": "#B71C1C",
	"accent-1": "#FF8A80",
	"accent-2": "#FF5252",
	"accent-3": "#FF1744",
	"accent-4": "#D50000"
};
var pink = {
	"lighten-5": "#fce4ec",
	"lighten-4": "#f8bbd0",
	"lighten-3": "#f48fb1",
	"lighten-2": "#f06292",
	"lighten-1": "#ec407a",
	base: "#e91e63",
	"darken-1": "#d81b60",
	"darken-2": "#c2185b",
	"darken-3": "#ad1457",
	"darken-4": "#880e4f",
	"accent-1": "#ff80ab",
	"accent-2": "#ff4081",
	"accent-3": "#f50057",
	"accent-4": "#c51162"
};
var purple = {
	"lighten-5": "#f3e5f5",
	"lighten-4": "#e1bee7",
	"lighten-3": "#ce93d8",
	"lighten-2": "#ba68c8",
	"lighten-1": "#ab47bc",
	base: "#9c27b0",
	"darken-1": "#8e24aa",
	"darken-2": "#7b1fa2",
	"darken-3": "#6a1b9a",
	"darken-4": "#4a148c",
	"accent-1": "#ea80fc",
	"accent-2": "#e040fb",
	"accent-3": "#d500f9",
	"accent-4": "#aa00ff"
};
var indigo = {
	"lighten-5": "#e8eaf6",
	"lighten-4": "#c5cae9",
	"lighten-3": "#9fa8da",
	"lighten-2": "#7986cb",
	"lighten-1": "#5c6bc0",
	base: "#3f51b5",
	"darken-1": "#3949ab",
	"darken-2": "#303f9f",
	"darken-3": "#283593",
	"darken-4": "#1a237e",
	"accent-1": "#8c9eff",
	"accent-2": "#536dfe",
	"accent-3": "#3d5afe",
	"accent-4": "#304ffe"
};
var blue = {
	"lighten-5": "#E3F2FD",
	"lighten-4": "#BBDEFB",
	"lighten-3": "#90CAF9",
	"lighten-2": "#64B5F6",
	"lighten-1": "#42A5F5",
	base: "#2196F3",
	"darken-1": "#1E88E5",
	"darken-2": "#1976D2",
	"darken-3": "#1565C0",
	"darken-4": "#0D47A1",
	"accent-1": "#82B1FF",
	"accent-2": "#448AFF",
	"accent-3": "#2979FF",
	"accent-4": "#2962FF"
};
var cyan = {
	"lighten-5": "#e0f7fa",
	"lighten-4": "#b2ebf2",
	"lighten-3": "#80deea",
	"lighten-2": "#4dd0e1",
	"lighten-1": "#26c6da",
	base: "#00bcd4",
	"darken-1": "#00acc1",
	"darken-2": "#0097a7",
	"darken-3": "#00838f",
	"darken-4": "#006064",
	"accent-1": "#84ffff",
	"accent-2": "#18ffff",
	"accent-3": "#00e5ff",
	"accent-4": "#00b8d4"
};
var teal = {
	"lighten-5": "#e0f2f1",
	"lighten-4": "#b2dfdb",
	"lighten-3": "#80cbc4",
	"lighten-2": "#4db6ac",
	"lighten-1": "#26a69a",
	base: "#009688",
	"darken-1": "#00897b",
	"darken-2": "#00796b",
	"darken-3": "#00695c",
	"darken-4": "#004d40",
	"accent-1": "#a7ffeb",
	"accent-2": "#64ffda",
	"accent-3": "#1de9b6",
	"accent-4": "#00bfa5"
};
var green = {
	"lighten-5": "#E8F5E9",
	"lighten-4": "#C8E6C9",
	"lighten-3": "#A5D6A7",
	"lighten-2": "#81C784",
	"lighten-1": "#66BB6A",
	base: "#4CAF50",
	"darken-1": "#43A047",
	"darken-2": "#388E3C",
	"darken-3": "#2E7D32",
	"darken-4": "#1B5E20",
	"accent-1": "#B9F6CA",
	"accent-2": "#69F0AE",
	"accent-3": "#00E676",
	"accent-4": "#00C853"
};
var lime = {
	"lighten-5": "#f9fbe7",
	"lighten-4": "#f0f4c3",
	"lighten-3": "#e6ee9c",
	"lighten-2": "#dce775",
	"lighten-1": "#d4e157",
	base: "#cddc39",
	"darken-1": "#c0ca33",
	"darken-2": "#afb42b",
	"darken-3": "#9e9d24",
	"darken-4": "#827717",
	"accent-1": "#f4ff81",
	"accent-2": "#eeff41",
	"accent-3": "#c6ff00",
	"accent-4": "#aeea00"
};
var yellow = {
	"lighten-5": "#fffde7",
	"lighten-4": "#fff9c4",
	"lighten-3": "#fff59d",
	"lighten-2": "#fff176",
	"lighten-1": "#ffee58",
	base: "#ffeb3b",
	"darken-1": "#fdd835",
	"darken-2": "#fbc02d",
	"darken-3": "#f9a825",
	"darken-4": "#f57f17",
	"accent-1": "#ffff8d",
	"accent-2": "#ffff00",
	"accent-3": "#ffea00",
	"accent-4": "#ffd600"
};
var amber = {
	"lighten-5": "#fff8e1",
	"lighten-4": "#ffecb3",
	"lighten-3": "#ffe082",
	"lighten-2": "#ffd54f",
	"lighten-1": "#ffca28",
	base: "#ffc107",
	"darken-1": "#ffb300",
	"darken-2": "#ffa000",
	"darken-3": "#ff8f00",
	"darken-4": "#ff6f00",
	"accent-1": "#ffe57f",
	"accent-2": "#ffd740",
	"accent-3": "#ffc400",
	"accent-4": "#ffab00"
};
var orange = {
	"lighten-5": "#fff3e0",
	"lighten-4": "#ffe0b2",
	"lighten-3": "#ffcc80",
	"lighten-2": "#ffb74d",
	"lighten-1": "#ffa726",
	base: "#ff9800",
	"darken-1": "#fb8c00",
	"darken-2": "#f57c00",
	"darken-3": "#ef6c00",
	"darken-4": "#e65100",
	"accent-1": "#ffd180",
	"accent-2": "#ffab40",
	"accent-3": "#ff9100",
	"accent-4": "#ff6d00"
};
var brown = {
	"lighten-5": "#efebe9",
	"lighten-4": "#d7ccc8",
	"lighten-3": "#bcaaa4",
	"lighten-2": "#a1887f",
	"lighten-1": "#8d6e63",
	base: "#795548",
	"darken-1": "#6d4c41",
	"darken-2": "#5d4037",
	"darken-3": "#4e342e",
	"darken-4": "#3e2723"
};
var grey = {
	"lighten-5": "#fafafa",
	"lighten-4": "#f5f5f5",
	"lighten-3": "#eeeeee",
	"lighten-2": "#e0e0e0",
	"lighten-1": "#bdbdbd",
	base: "#9e9e9e",
	"darken-1": "#757575",
	"darken-2": "#616161",
	"darken-3": "#424242",
	"darken-4": "#212121"
};
var black = {
	base: "#000000"
};
var white = {
	base: "#FFFFFF"
};
var colors = {
	red: red,
	pink: pink,
	purple: purple,
	"deep-purple": {
	"lighten-5": "#ede7f6",
	"lighten-4": "#d1c4e9",
	"lighten-3": "#b39ddb",
	"lighten-2": "#9575cd",
	"lighten-1": "#7e57c2",
	base: "#673ab7",
	"darken-1": "#5e35b1",
	"darken-2": "#512da8",
	"darken-3": "#4527a0",
	"darken-4": "#311b92",
	"accent-1": "#b388ff",
	"accent-2": "#7c4dff",
	"accent-3": "#651fff",
	"accent-4": "#6200ea"
},
	indigo: indigo,
	blue: blue,
	"light-blue": {
	"lighten-5": "#e1f5fe",
	"lighten-4": "#b3e5fc",
	"lighten-3": "#81d4fa",
	"lighten-2": "#4fc3f7",
	"lighten-1": "#29b6f6",
	base: "#03a9f4",
	"darken-1": "#039be5",
	"darken-2": "#0288d1",
	"darken-3": "#0277bd",
	"darken-4": "#01579b",
	"accent-1": "#80d8ff",
	"accent-2": "#40c4ff",
	"accent-3": "#00b0ff",
	"accent-4": "#0091ea"
},
	cyan: cyan,
	teal: teal,
	green: green,
	"light-green": {
	"lighten-5": "#f1f8e9",
	"lighten-4": "#dcedc8",
	"lighten-3": "#c5e1a5",
	"lighten-2": "#aed581",
	"lighten-1": "#9ccc65",
	base: "#8bc34a",
	"darken-1": "#7cb342",
	"darken-2": "#689f38",
	"darken-3": "#558b2f",
	"darken-4": "#33691e",
	"accent-1": "#ccff90",
	"accent-2": "#b2ff59",
	"accent-3": "#76ff03",
	"accent-4": "#64dd17"
},
	lime: lime,
	yellow: yellow,
	amber: amber,
	orange: orange,
	"deep-orange": {
	"lighten-5": "#fbe9e7",
	"lighten-4": "#ffccbc",
	"lighten-3": "#ffab91",
	"lighten-2": "#ff8a65",
	"lighten-1": "#ff7043",
	base: "#ff5722",
	"darken-1": "#f4511e",
	"darken-2": "#e64a19",
	"darken-3": "#d84315",
	"darken-4": "#bf360c",
	"accent-1": "#ff9e80",
	"accent-2": "#ff6e40",
	"accent-3": "#ff3d00",
	"accent-4": "#dd2c00"
},
	brown: brown,
	"blue-grey": {
	"lighten-5": "#eceff1",
	"lighten-4": "#cfd8dc",
	"lighten-3": "#b0bec5",
	"lighten-2": "#90a4ae",
	"lighten-1": "#78909c",
	base: "#607d8b",
	"darken-1": "#546e7a",
	"darken-2": "#455a64",
	"darken-3": "#37474f",
	"darken-4": "#263238"
},
	grey: grey,
	black: black,
	white: white
};

// Default shade is "base"
//
// e.g. color("red") returns "#F44336"
//      color("light-blue", "darken-2") returns "#0288d1"

function color(name) {
  var shade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
  return colors[name][shade];
}

function IconToggle(_ref) {
  var color$$1 = _ref.color,
      label = _ref.label,
      offIcon = _ref.offIcon,
      onIcon = _ref.onIcon;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "icon-toggle",
    onClick: function onClick() {
      return setActive(!active);
    },
    style: {
      color: color$$1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ripple",
    style: {
      backgroundColor: color$$1
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: active ? onIcon : offIcon,
    label: label
  }));
}
IconToggle.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  offIcon: PropTypes.string.isRequired,
  onIcon: PropTypes.string.isRequired
};
IconToggle.defaultProps = {
  color: color("black"),
  label: '',
  offIcon: '',
  onIcon: ''
};

function iconLabel(type) {
  switch (type) {
    case 'danger':
      return 'Alert';

    case 'warning':
      return 'Warning';

    default:
      return 'Info';
  }
}

function iconName(type) {
  switch (type) {
    case 'danger':
      return 'cancel';

    case 'warning':
      return 'warning';

    default:
      return 'info';
  }
}

function InfoBanner(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      type = _ref.type;
  var bannerClasses = classNames((_classNames = {
    'align-items-center': true,
    'd-flex': true,
    'font-italic': true
  }, _defineProperty(_classNames, 'text-' + type, true), _defineProperty(_classNames, className, className), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: bannerClasses
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: iconName(type),
    label: iconLabel(type),
    className: "h3-responsive"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pl-2"
  }, children));
}

InfoBanner.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  type: PropTypes.oneOf(['info', 'warning', 'danger'])
};
InfoBanner.defaultProps = {
  children: [],
  className: '',
  type: 'info'
};

/*
# Helpers for use with N2Modal and N2ModalTrigger
#
# TODO: Investigate why setup/teardown are necessary when triggering Bootstrap modal from React
# Both N2 Note Modals and these N2Modals do not trap focus or respond to the escape key,
# Unless code like this is used for teardown/setup
*/

function focusable() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var items = ['input', 'textarea', 'select', 'button', 'a[href]', 'area[href]', 'details', 'iframe', '[tabindex]', '[contentEditable]'];
  return items.map(function (item) {
    return "".concat(selector, " ").concat(item);
  }).join(', ');
}

function hideModalIfEscaped(modalNode, event) {
  if (event.key === 'Escape') {
    // eslint-disable-next-line no-use-before-define
    hide(modalNode);
  }
}

function respondToEscapeKey(modalNode) {
  $('.modal-open').on('keydown', hideModalIfEscaped.bind(this, modalNode));
}

function releaseFocus() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  $(focusable(selector)).each(function makeFocusable() {
    // restore tabIndex from data attributes
    var prevIndex = $(this).data('tabIndex');

    if (!prevIndex) {
      return $(this).removeAttr('tabIndex');
    }

    return $(this).attr('tabIndex', prevIndex);
  });
}

function trapFocus(selector) {
  var allFocusable = focusable(); // Remove focus from everything, and store tabIndex in data attributes

  $(allFocusable).each(function makeUnfocusable() {
    $(this).data('tabIndex', $(this).attr('tabIndex'));
    $(this).attr('tabIndex', '-1');
  }); // Focus items in selector

  releaseFocus(selector);
}

function restoreFocus() {
  var initialFocus = $('[data-initial-focus]');
  initialFocus.first().focus();
  initialFocus.removeData('initialFocus');
}

function setup(modalSelector) {
  trapFocus(modalSelector); // store initial focus in data attributes

  document.activeElement.dataset.initialFocus = true; // blur active element and focus inside modal

  document.activeElement.blur();
  $(focusable(modalSelector)).first().focus(); // respond to escape key

  respondToEscapeKey($(modalSelector));
}

function teardown() {
  // Remove event listener so it does not error
  $('.modal-open').off('keydown');
  releaseFocus();
  restoreFocus();
}

function hide(modalSelector) {
  var modal = $(modalSelector);
  modal.modal('hide');
}
function show(modalSelector) {
  var modal = $(modalSelector);
  modal.modal({
    show: false,
    keyboard: true,
    focus: true
  }); // This should not be necessary, but I find that it is

  modal.on('shown.bs.modal', function () {
    return setup(modalSelector);
  });
  modal.on('hide.bs.modal', function () {
    return teardown(modalSelector);
  });
  modal.modal('show');
}
function mount(mountSelector, modalComponent) {
  ReactDOM.unmountComponentAtNode($(mountSelector)[0]);
  ReactDOM.render(modalComponent, $(mountSelector)[0]);
}

/*
## Modal triggered from React
*/

var modalDialogClass = function modalDialogClass(size) {
  switch (size) {
    case 'small':
      return 'modal-sm';

    case 'large':
      return 'modal-lg';

    case 'extraLarge':
      return 'modal-xl';

    default:
      return '';
  }
};

function Modal(props) {
  var children = props.children,
      className = props.className,
      dismissText = props.dismissText,
      footer = props.footer,
      modalSelectorClass = props.modalSelectorClass,
      onDismiss = props.onDismiss,
      onSubmit = props.onSubmit,
      showDismissIcon = props.showDismissIcon,
      submitText = props.submitText,
      title = props.title,
      size = props.size;
  var modalSelector = ".".concat(modalSelectorClass);
  var sizeClass = modalDialogClass(size);

  function close() {
    hide(modalSelector);
  }

  function dismiss() {
    onDismiss();
    close();
  }

  function submit() {
    onSubmit()["finally"](function () {
      return close();
    });
  } // Row reverse the buttons so that if submit exists, it is on the right but first in tab order


  var defaultFooter = /*#__PURE__*/React.createElement("div", {
    className: "modal-footer border-0 pb-3 pl-0 pr-0 d-flex flex-row-reverse justify-content-between"
  }, onSubmit && /*#__PURE__*/React.createElement(Button, {
    style: "primary" // eslint-disable-line
    ,
    className: "m-0 waves-effect",
    type: "submit",
    onClick: submit,
    autoFocus: true
  }, submitText), /*#__PURE__*/React.createElement(Button, {
    style: "flat" // eslint-disable-line
    ,
    className: "m-0 waves-effect",
    onClick: dismiss
  }, dismissText));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('modal fade', className, modalSelectorClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('modal-dialog', sizeClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header border-0 px-3 pt-3 pb-0"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "modal-title grey-text text-darken-3 w-100"
  }, title), showDismissIcon && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    "aria-label": "Close",
    onClick: dismiss,
    dangerouslySetInnerHTML: {
      __html: '&times'
    } // eslint-disable-line react/no-danger

  })), /*#__PURE__*/React.createElement("div", {
    className: "modal-body p-3"
  }, children, footer || defaultFooter))));
}

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  dismissText: PropTypes.string,
  footer: PropTypes.node,
  modalSelectorClass: PropTypes.string.isRequired,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  size: PropTypes.oneOf(['default', 'small', 'large', 'extraLarge']),
  showDismissIcon: PropTypes.bool,
  submitText: PropTypes.string,
  title: PropTypes.string.isRequired
};
Modal.defaultProps = {
  children: [],
  className: '',
  dismissText: 'Dismiss',
  onDismiss: function onDismiss() {},
  onSubmit: undefined,
  footer: null,
  size: 'default',
  showDismissIcon: false,
  submitText: 'Ok'
};

function ModalTrigger(_ref) {
  var mountSelector = _ref.mountSelector,
      modalSelector = _ref.modalSelector,
      modalComponent = _ref.modalComponent,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["mountSelector", "modalSelector", "modalComponent", "children"]);

  function mountModal() {
    mount(mountSelector, modalComponent);
    show(modalSelector);
  }

  return /*#__PURE__*/React.createElement(Button, _extends({
    onClick: mountModal
  }, otherProps), children);
}

ModalTrigger.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  modalComponent: PropTypes.node.isRequired,
  modalSelector: PropTypes.string.isRequired,
  mountSelector: PropTypes.string.isRequired
};
ModalTrigger.defaultProps = {
  children: []
};

var Note = /*#__PURE__*/function (_React$Component) {
  _inherits(Note, _React$Component);

  var _super = _createSuper(Note);

  function Note() {
    _classCallCheck(this, Note);

    return _super.apply(this, arguments);
  }

  _createClass(Note, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          note = _this$props.note,
          onClick = _this$props.onClick;
      var id = note.id,
          text = note.text,
          archived = note.archived;
      var textClass = archived ? 'text-lighten-1' : 'text-darken-3'; // Use button for accessibility, but override style defaults

      var buttonStyle = {
        fontSize: 'unset',
        fontWeight: 'unset',
        textTransform: 'none'
      };
      return /*#__PURE__*/React.createElement("li", {
        className: "list-group-item cursor-pointer px-3 u-wrap py-1"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn-flat p-0 m-0 text-left",
        style: buttonStyle,
        type: "button",
        onClick: onClick,
        "data-id": id,
        "data-archived": archived
      }, /*#__PURE__*/React.createElement("p", {
        className: "grey-text mb-0 js-note-text ".concat(textClass)
      }, text), /*#__PURE__*/React.createElement("p", {
        className: "grey-text mb-0 mt-2 label ".concat(textClass)
      }, this.createdAt)));
    }
  }, {
    key: "createdAt",
    get: function get() {
      var createdAt = this.props.note.created_at;
      return moment(createdAt).format('MMMM Do, YYYY [at] h:mm a');
    }
  }]);

  return Note;
}(React.Component);

Note.propTypes = {
  note: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    archived: PropTypes.bool,
    created_at: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func
};
Note.defaultProps = {
  onClick: function onClick() {}
};

var NotesPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(NotesPanel, _React$Component);

  var _super = _createSuper(NotesPanel);

  function NotesPanel(props) {
    var _this;

    _classCallCheck(this, NotesPanel);

    _this = _super.call(this, props);
    _this.state = {
      showArchived: _this.getShowArchived()
    };
    _this.mountModal = _this.mountModal.bind(_assertThisInitialized(_this));
    _this.changeArchive = _this.changeArchive.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NotesPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $('.js-open-notes').sideNav({
        edge: 'right'
      });
    } // eslint-disable-next-line class-methods-use-this, react/sort-comp

  }, {
    key: "compareDateCreated",
    value: function compareDateCreated(a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    }
  }, {
    key: "changeArchive",
    value: function changeArchive(evt) {
      localStorage.setItem('showArchived', evt.target.checked);
      this.setState({
        showArchived: evt.target.checked
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "setDay",
    value: function setDay(date) {
      if (moment(date).isSame(moment(), 'day')) {
        return 'Today';
      }

      if (moment(date).isSame(moment().subtract(1, 'day'), 'day')) {
        return 'Yesterday';
      }

      return moment(date).format('ll');
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getShowArchived",
    value: function getShowArchived() {
      return JSON.parse(localStorage.getItem('showArchived')) || false;
    }
  }, {
    key: "modalSelector",
    value: function modalSelector() {
      return ".".concat(this.modalSelectorClass());
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "modalSelectorClass",
    value: function modalSelectorClass() {
      return 'js-notes-modal';
    }
  }, {
    key: "mountModal",
    value: function mountModal(evt) {
      ReactDOM.unmountComponentAtNode($('.js-note-modal-container')[0]); // data('id') and 'text' is intentionally null if coming from New Notes button

      var $target = $(evt.currentTarget);
      var _this$props = this.props,
          notableId = _this$props.notable_id,
          notableType = _this$props.notable_type;
      var modal = /*#__PURE__*/React.createElement(NoteModal, {
        modalSelectorClass: this.modalSelectorClass(),
        notableId: notableId,
        notableType: notableType,
        noteId: $target.attr('data-id'),
        noteText: $target.find('.js-note-text').text(),
        archived: $target.attr('data-archived')
      });
      var mountSelector = '.js-note-modal-container';

      mount(mountSelector, modal);

      show(this.modalSelector());
    }
  }, {
    key: "updateNoteCount",
    value: function updateNoteCount() {
      var notes = this.props.notes;
      var k = 0;
      $.grep(notes, function (n) {
        $.each(n[1], function (i, note) {
          // eslint-disable-next-line eqeqeq
          if (note.archived != true) {
            k += 1;
          }
        });
      });
      var noteCountText;

      if (k === 0) {
        $('.js-note-count-nav').addClass('hidden');
      } else if (k === 1) {
        $('.js-note-count-nav').removeClass('hidden');
        noteCountText = "".concat(k, " Note");
      } else {
        noteCountText = "".concat(k, " Notes");
      }

      $('.js-non-archived-note-count').text(noteCountText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.updateNoteCount();
      var notes = this.props.notes;
      var showArchived = this.state.showArchived;
      var data = notes.map(function (group) {
        var dateDisplay = _this2.setDay(group[0]);

        var groupArchived = group[1].filter(function (note) {
          return note.archived && note.id;
        }).length;
        var allArchived = groupArchived === group[1].length;
        var dateClass = allArchived ? 'text-lighten-1' : 'text-darken-3';

        if (allArchived && !showArchived) {
          return false;
        }

        return /*#__PURE__*/React.createElement("div", {
          key: group[0]
        }, /*#__PURE__*/React.createElement("div", {
          className: "container p-3"
        }, /*#__PURE__*/React.createElement("div", {
          className: "d-flex flex-row"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "grey-text mb-0 ".concat(dateClass)
        }, dateDisplay))), /*#__PURE__*/React.createElement("ul", {
          className: "simple-top-border mb-0"
        }, group[1].sort(_this2.compareDateCreated).map(function (note) {
          if (note.archived && !showArchived) {
            return false;
          }

          return /*#__PURE__*/React.createElement(Note, {
            note: note,
            onClick: _this2.mountModal,
            key: note.id
          });
        })));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "side-nav large",
        id: "notes-side-nav"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container px-3 pt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row mb-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4 pl-0"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "grey-text text-darken-3"
      }, "Notes")), /*#__PURE__*/React.createElement("div", {
        className: "col-8 grey-text text-darken-3"
      }, /*#__PURE__*/React.createElement("fieldset", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "archived-notes",
        checked: showArchived,
        onChange: this.changeArchive
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "archived-notes",
        className: "fs-small grey-text text-darken-3"
      }, "Show Archived")))), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row mb-2"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "m-0",
        onClick: this.mountModal
      }, "New Note"))), data);
    }
  }]);

  return NotesPanel;
}(React.Component);

NotesPanel.propTypes = {
  notes: PropTypes.arrayOf(function (propValue, key, componentName, location, propFullName) {
    if (Array.isArray(propValue[key])) {
      return new Error("Invalid prop ".concat(propFullName, " passed to ").concat(componentName, ". Expected item to be an array."));
    }

    return null;
  }),
  notable_id: PropTypes.number.isRequired,
  notable_type: PropTypes.string.isRequired
};
NotesPanel.defaultProps = {
  notes: []
};

var NoteModal = /*#__PURE__*/function (_React$Component) {
  _inherits(NoteModal, _React$Component);

  var _super = _createSuper(NoteModal);

  function NoteModal(props) {
    var _this;

    _classCallCheck(this, NoteModal);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        noteText = _this$props.noteText,
        archived = _this$props.archived;
    _this.state = _objectSpread2({}, props, {
      noteText: noteText || '',
      // eslint-disable-next-line eqeqeq
      archived: archived == 'true'
    });
    _this.onTextChange = _this.onTextChange.bind(_assertThisInitialized(_this));
    _this.updateNote = _this.updateNote.bind(_assertThisInitialized(_this));
    _this.saveNewNote = _this.saveNewNote.bind(_assertThisInitialized(_this));
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    _this.deleteNote = _this.deleteNote.bind(_assertThisInitialized(_this));
    _this.archiveNote = _this.archiveNote.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NoteModal, [{
    key: "onTextChange",
    value: function onTextChange(event) {
      this.setState({
        noteText: event.target.value
      });
    }
  }, {
    key: "addNote",
    value: function addNote(note) {
      var date = moment().format('Y-MM-DD');

      var _$$data = $('.js-notes-side-nav').data('reactProps'),
          notes = _$$data.notes; // eslint-disable-next-line eqeqeq


      var notesToday = $.grep(notes, function (n) {
        return n[0] == date;
      });
      var noteArr = notes.map(function (group) {
        return $.grep(group[1], function (n) {
          return parseInt(n.id, 10) === parseInt(note.id, 10);
        });
      });
      var currNote = noteArr.filter(function (n) {
        return n && n.length;
      });

      if (currNote.length) {
        currNote[0][0].text = note.text;
        currNote[0][0].archived = !!note.archived_at;
      } else if (notesToday.length) {
        notes[0][1].unshift(note);
      } else {
        notes.unshift([date, Array(note)]);
      }

      this.renderSideNav(notes);
    }
  }, {
    key: "addInputs",
    value: function addInputs(form) {
      var _this$state = this.state,
          notableId = _this$state.notableId,
          notableType = _this$state.notableType;
      form.setRootParam('n2_notable_notes');
      form.addInput('notable_id', notableId);
      form.addInput('notable_type', notableType);
    }
  }, {
    key: "archiveNote",
    value: function archiveNote() {
      var _this$state2 = this.state,
          archived = _this$state2.archived,
          noteId = _this$state2.noteId;
      var archive = !archived; // eslint-disable-next-line new-cap

      var form = new N2Styles.manualForm("/n2_notable/notes/".concat(noteId));
      form.addInput('archive', archive);
      form.form.attr('method', 'patch');
      this.addInputs(form);
      this.sendToServer(form);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "close",
    value: function close() {
      var modalSelectorClass = this.props.modalSelectorClass;
      hide(".".concat(modalSelectorClass));
    }
  }, {
    key: "deleteNote",
    value: function deleteNote() {
      var noteId = this.state.noteId; // eslint-disable-next-line new-cap

      var form = new N2Styles.manualForm("/n2_notable/notes/".concat(noteId));
      form.form.attr('method', 'delete');
      this.sendToServer(form);
    }
  }, {
    key: "newNoteButtons",
    value: function newNoteButtons() {
      return /*#__PURE__*/React.createElement("div", {
        className: "modal-footer p-0 pt-3 border-0 d-flex flex-row justify-content-between"
      }, /*#__PURE__*/React.createElement(Button, {
        style: "flat" // eslint-disable-line react/style-prop-object
        ,
        className: "m-0 waves-effect",
        onClick: this.close
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        style: "primary" // eslint-disable-line react/style-prop-object
        ,
        className: "m-0 waves-effect waves-light",
        onClick: this.saveNewNote
      }, "Save"));
    }
  }, {
    key: "sendToServer",
    value: function sendToServer(form) {
      var _this2 = this;

      form.sync({
        success: function success(resp) {
          _this2.close();

          _this2.showMessage(resp.notice);

          _this2.updateNotesUI(resp);
        },
        error: function error(req) {
          _this2.close();

          var message = req.responseJSON && req.responseJSON.alert || "Request failed: ".concat(req.status);

          _this2.showMessage(message);
        },
        context: this
      });
    }
  }, {
    key: "saveNewNote",
    value: function saveNewNote() {
      var noteText = this.state.noteText; // eslint-disable-next-line new-cap

      var form = new N2Styles.manualForm('/n2_notable/notes');
      form.addInput('text', noteText);
      form.form.attr('method', 'post');
      this.addInputs(form);
      this.sendToServer(form);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "showMessage",
    value: function showMessage(msg) {
      // eslint-disable-next-line new-cap, no-new
      new N2Styles.toast(msg);
    }
  }, {
    key: "updateNote",
    value: function updateNote() {
      var _this$state3 = this.state,
          noteId = _this$state3.noteId,
          noteText = _this$state3.noteText; // eslint-disable-next-line new-cap

      var form = new N2Styles.manualForm("/n2_notable/notes/".concat(noteId));
      form.addInput('text', noteText);
      form.form.attr('method', 'patch');
      this.addInputs(form);
      this.sendToServer(form);
    }
  }, {
    key: "updateNoteButtons",
    value: function updateNoteButtons() {
      var archived = this.state.archived;
      var archiveButton = archived ? 'Restore' : 'Archive';
      return /*#__PURE__*/React.createElement("div", {
        className: "modal-footer p-0 pt-3 border-0 d-flex flex-row justify-content-between"
      }, /*#__PURE__*/React.createElement(Button, {
        style: "flat" // eslint-disable-line react/style-prop-object
        ,
        className: "m-0 red-text waves-effect",
        onClick: this.deleteNote
      }, "Delete"), /*#__PURE__*/React.createElement(Button, {
        style: "flat" // eslint-disable-line react/style-prop-object
        ,
        className: "m-0 waves-effect",
        onClick: this.archiveNote
      }, archiveButton), !archived && /*#__PURE__*/React.createElement(Button, {
        style: "primary" // eslint-disable-line react/style-prop-object
        ,
        className: "m-0 waves-effect waves-light",
        onClick: this.updateNote
      }, "Save"));
    }
  }, {
    key: "updateNotesUI",
    value: function updateNotesUI(resp) {
      if (parseInt(resp.status_code, 10) === 1) {
        // on a destroy
        this.removeNote(resp.note);
      } else {
        // on a save or update
        this.addNote(resp.note);
      }
    }
  }, {
    key: "removeNote",
    value: function removeNote(note) {
      var _$$data2 = $('.js-notes-side-nav').data('reactProps'),
          notes = _$$data2.notes;

      $.each(notes, function (i, group) {
        if (!group) {
          return;
        }

        $.grep(group[1], function (n) {
          if (!n) {
            return;
          }

          if (parseInt(n.id, 10) === parseInt(note.id, 10)) {
            group[1].splice(group[1].indexOf(n), 1);

            if (!group[1].length) {
              notes.splice(notes.indexOf(group), 1);
            }
          }
        });
      });
      this.renderSideNav(notes.filter(function (n) {
        return n && n.length;
      }));
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "renderSideNav",
    value: function renderSideNav(notes) {
      var notesSelector = '.js-notes-side-nav';
      var node = $(notesSelector);
      var id = node.data('reactProps').notable_id;
      var type = node.data('reactProps').notable_type;
      ReactDOM.render( /*#__PURE__*/React.createElement(NotesPanel, {
        notes: notes,
        notable_id: id,
        notable_type: type
      }), node[0]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          noteId = _this$state4.noteId,
          noteText = _this$state4.noteText,
          archived = _this$state4.archived;
      var modalSelectorClass = this.props.modalSelectorClass;
      var title = noteId ? 'Edit Note' : 'New Note';
      var buttons = noteId ? this.updateNoteButtons() : this.newNoteButtons();
      var content = /*#__PURE__*/React.createElement("div", {
        className: "md-form md-textarea-container mb-0 px-0"
      }, /*#__PURE__*/React.createElement("textarea", {
        id: "form_textarea",
        className: "md-textarea py-3",
        value: noteText,
        readOnly: archived,
        onChange: this.onTextChange
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "form_textarea"
      }, "Type your note here..."));
      return /*#__PURE__*/React.createElement(Modal, {
        title: title,
        modalSelectorClass: modalSelectorClass,
        footer: buttons
      }, content);
    }
  }]);

  return NoteModal;
}(React.Component);

NoteModal.propTypes = {
  modalSelectorClass: PropTypes.string.isRequired,
  noteText: PropTypes.string,
  archived: PropTypes.string
};
NoteModal.defaultProps = {
  noteText: '',
  archived: 'false'
};

function SegmentedLink(_ref) {
  var label = _ref.label,
      href = _ref.href,
      active = _ref.active;
  var classes = classNames('segmented-control', {
    active: active
  });
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    className: classes
  }, label);
}

function SegmentedControls(_ref) {
  var color = _ref.color,
      items = _ref.items,
      currentHref = _ref.currentHref,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["color", "items", "currentHref", "className"]);

  var classes = classNames('segmented-controls', color, className); // Assign 'active' property for each item if it's not already set
  // If 'currentHref' is provided, match each href against it

  var itemsWithActiveStatus = items.map(function (item) {
    if (item.hasOwnProperty('active')) return item;
    if (currentHref) return _objectSpread2({}, item, {
      active: item.href == currentHref
    });
    return _objectSpread2({}, item, {
      active: false
    });
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classes
  }), itemsWithActiveStatus.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SegmentedLink, _extends({
      key: index
    }, item));
  }));
}

function TableHeader(props) {
  var columns = props.columns;
  return /*#__PURE__*/React.createElement("div", {
    className: "list-group-item d-flex flex-row align-items-center justify-content-center mx-n3 px-1 w-auto"
  }, columns.map(function (column) {
    var sorted = column.sorted,
        sortUrl = column.sortUrl,
        reverse = column.reverse,
        colSpan = column.colSpan,
        textAlign = column.textAlign,
        key = column.key,
        title = column.title;
    var textColorClass = sorted ? '' : 'grey-text';
    var colSpanClass = colSpan ? "col-".concat(colSpan) : '';
    var textAlignClass = textAlign ? "text-".concat(textAlign) : '';
    var icon = reverse ? 'arrow_drop_up' : 'arrow_drop_down';
    var sortIcon = sortUrl ? /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      className: "align-bottom"
    }) : '';
    var headerContents = /*#__PURE__*/React.createElement("span", null, title, sortIcon);
    var justifyContentClass = '';

    switch (textAlign) {
      case 'left':
        justifyContentClass = 'justify-content-start';
        break;

      case 'center':
        justifyContentClass = 'justify-content-around';
        break;

      case 'right':
        justifyContentClass = 'justify-content-end';
        break;

      default:
        justifyContentClass = '';
    }

    var linkClasses = classNames('d-flex align-items-center ml-0', textColorClass, justifyContentClass);
    var header = headerContents;

    if (sortUrl) {
      header = /*#__PURE__*/React.createElement("a", {
        className: linkClasses,
        href: sortUrl
      }, headerContents);
    }

    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classNames('flex-column text-wrap', colSpanClass, textColorClass, textAlignClass)
    }, header);
  }));
}

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    textAlign: PropTypes.string,
    colSpan: PropTypes.number,
    reverse: PropTypes.bool,
    sortUrl: PropTypes.string,
    sorted: PropTypes.bool,
    render: PropTypes.func,
    dataIndex: PropTypes.string
  }))
};
TableHeader.defaultProps = {
  columns: []
};

function TableRow(props) {
  var record = props.record,
      index = props.index,
      columns = props.columns,
      rowClassName = props.rowClassName;
  var rowClass = rowClassName(record, index);
  return /*#__PURE__*/React.createElement("li", {
    className: classNames('list-group-item d-flex flex-row align-items-center justify-content-center mx-n3 px-1 w-auto', rowClass)
  }, columns.map(function (column) {
    var key = column.key,
        colSpan = column.colSpan,
        textAlign = column.textAlign,
        render = column.render,
        dataIndex = column.dataIndex;
    var colSpanClass = colSpan ? "col-".concat(colSpan) : '';
    var textAlignClass = textAlign ? "text-".concat(textAlign) : '';
    var contents = render ? render(record, index) : record[dataIndex];
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classNames('d-flex flex-column text-wrap', colSpanClass, textAlignClass)
    }, contents);
  }));
}

TableRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    textAlign: PropTypes.string,
    colSpan: PropTypes.number,
    reverse: PropTypes.bool,
    sortUrl: PropTypes.string,
    sorted: PropTypes.bool,
    render: PropTypes.func,
    dataIndex: PropTypes.string
  })),
  index: PropTypes.number,
  record: PropTypes.object,
  // eslint-disable-line
  rowClassName: PropTypes.func
};
TableRow.defaultProps = {
  columns: [],
  index: 0,
  record: {},
  rowClassName: function rowClassName() {}
};

function Table(props) {
  var columns = props.columns,
      dataSource = props.dataSource,
      rowKey = props.rowKey,
      rowClassName = props.rowClassName;
  return /*#__PURE__*/React.createElement("ul", {
    className: "list-group list-group-flush"
  }, /*#__PURE__*/React.createElement(TableHeader, {
    key: "header",
    columns: columns
  }), dataSource.map(function (record, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: record[rowKey],
      record: record,
      index: index,
      columns: columns,
      rowClassName: rowClassName
    });
  }), /*#__PURE__*/React.createElement("li", {
    className: "list-group-item d-flex flex-row align-items-center justify-content-center mx-n3 px-3 w-auto"
  }));
}

Table.propTypes = {
  dataSource: PropTypes.array,
  // eslint-disable-line
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    textAlign: PropTypes.string,
    colSpan: PropTypes.number,
    reverse: PropTypes.bool,
    sortable: PropTypes.bool,
    sortUrl: PropTypes.string,
    sorted: PropTypes.bool,
    render: PropTypes.func,
    dataIndex: PropTypes.string
  })),
  rowClassName: PropTypes.func,
  rowKey: PropTypes.string
};
Table.defaultProps = {
  columns: [],
  dataSource: [],
  rowClassName: function rowClassName() {},
  rowKey: 'key'
};

export { Avatar, Banner, Button, IconButton, Card, CardBody, CardContent, CardFooter, CardHeader, CardImage, Chip, FormError, FormLabel, Input, Select, Icon, IconToggle, InfoBanner, Modal, ModalTrigger, Note, NoteModal, NotesPanel, SegmentedControls, SegmentedLink, Table, TableHeader, TableRow, color, show as showModal, hide as hideModal, mount as mountModal };
